import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { useSelector } from "react-redux";

function Loading() {
  const { componentHeight } = useSelector((state) => state?.general);

  return (
    <div className="w-full gap-GAP-1 flex justify-center items-center flex-col" style={{ height: `${componentHeight}vh` }}>
      <ClipLoader
        color= {"var(--COLOR)"}
        size={80}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      <p className="text-[1.5rem] text-neutral-500">Loading...</p>
    </div>
  );
}

export default Loading;
